export const HERO_PRIMARY_BUTTON =
  'inline-flex h-12 w-full items-center justify-center whitespace-nowrap rounded-lg bg-white px-4 text-[15px] sm:h-11 sm:w-auto sm:rounded-md sm:text-sm font-medium text-primary-ink-100 no-underline transition-colors hover:bg-primary-ink-6 sm:px-5'
export const HERO_SECONDARY_BUTTON =
  'inline-flex h-12 w-full items-center justify-center whitespace-nowrap rounded-lg border border-white/25 px-4 text-[15px] sm:h-11 sm:w-auto sm:rounded-md sm:text-sm font-medium text-white no-underline transition-colors hover:bg-white/10 sm:px-5'

export default function MarketplaceHeroPanel({ children }: { children: React.ReactNode }) {
  return (
    // Full-bleed ink under the dark navbar, like the rest of the marketing site's heroes
    <section className="bg-primary-ink-100">
      <div className="container">{children}</div>
    </section>
  )
}
